import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
    cardContainer: {
        '& .MuiCard-root': {
            backgroundColor: theme.palette.background.main
        }
    }
}));